class StringFormatter {
  capitalizeFirst(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
  }
}
export default StringFormatter;
